import CalendarView from './CalendarView.vue';

export default CalendarView;
